export default {
  header: {
    back: {
      url: 'http://chaumet.com/kr',
      content: '홈페이지로 돌아가기'
    }
  },
  playerCover: {
    title: '쇼메의 세계',
    content: '2018년 6월 28일부터 9월 17일까지',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: '더 보기',
  worldDiscover: {
    title: {
      firstPart: '자세히 보기',
      secondPart: '‘쇼메의 세계’'
    },
    content:
      "쇼메는 도쿄 미츠비시 이치고칸 미술관에서 개최되는  '쇼메의 세계' 전시를 통해 브랜드 역사와 문화, 주얼리 메이킹 노하우를 만날 수 있는 여행으로 여러분을 초대합니다.",
    worlds: {
      types: [
        {
          title: '조세핀',
          content: '메종의 뮤즈',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: '쇼메',
          content: '방돔 광장 12번지에 위치한 방돔 광장 최초의 주얼러',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: '쇼메와 일본',
          content: '여행으로의 초대',
          img: 'home/world/japon.jpg',
          url: 'japan'
        },
        {
          title: '자연',
          content: '마르지 않는 영감의 원천',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: '아트 오브 디아뎀',
          content: '디아뎀의 탄생',
          img: 'home/world/art.jpg',
          url: 'tiara'
        },
        {
          title: '황실의 정선',
          content: '교황 비오 7세의 교황관_권력의 상징',
          img: 'home/world/pape.jpg',
          url: 'sovereigns'
        },
        {
          title: '감성을 전하는 주얼러',
          content: '변형 가능한 주얼리 예술',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: '쇼메와 소중한 순간을 기념하세요',
          content: '쇼메의 탁월한 주얼리 메이킹 노하우',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: '자세히 보기'
    },
    legend: '’쇼메의 세계’'
  },
  wall: {
    title: '#TheWorldsOfChaumet',
    content:
      '이번 전시회는 19세기 후반부터 전 세계에 걸쳐 명성을 떨치기 시작한  쇼메가 어떠한 방식으로 다양한 요소로부터 영감을 받아 쇼메만의 스타일을 완성하고 파리지앵 주얼러로서 유럽 및 세계의 역사에서 중요한 역할을 하게 되었는지 소개합니다. 쇼메는 또한 이번 전시회를 통해 18세기 말부터 깊은 인연을 맺었던 일본과 일본의 문화에 경의를 표합니다.',
    previous: '이전',
    next: '다음',
    cta: 'see more',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: '전시회 정보',
    exposition: {
      title: '쇼메의 세계(Les Mondes de Chaumet) 전시회',
      content:
        '2018년 6월 28일부터 9월 17일까지, 도쿄 미츠비시 이치고칸 뮤지엄(Mitsubischi Ichigokan Museum).'
    },
    museum: {
      link: {
        title: '뮤지엄 홈페이지 방문하기',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: '전시회 정보',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/kr/home.js